module.exports = __webpack_public_path__ + "static/media/20200506-1.a0e00471.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20200506/img/20200506-1.png
// module id = 316
// module chunks = 0